<nz-collapse>
  <nz-collapse-panel *ngFor="let approvalDecision of approvalDecisions" [nzHeader]="header" [nzActive]="true">
    <ng-template #header>
      {{approvalDecision.Authorizer}}
    </ng-template>
    <form nz-form>
      <nz-divider nzText="Authorization Details"></nz-divider>
      <nz-form-item>
        <nz-form-label [nzSpan]="6"> User </nz-form-label>
        <nz-form-control [nzSpan]="18">
          <input type="text" disabled nz-input value="{{ approvalDecision.Requester }}" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="6"> Remarks </nz-form-label>
        <nz-form-control [nzSpan]="18">
          <input type="text" disabled nz-input value="{{ approvalDecision.Remarks }}" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="6"> Template </nz-form-label>
        <nz-form-control [nzSpan]="18">
          <input type="text" disabled nz-input value="{{ approvalDecision.TemplateName }} <{{
          approvalDecision.TemplateRemark
        }}>" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="6"> Stage </nz-form-label>
        <nz-form-control [nzSpan]="18">
          <input type="text" disabled nz-input value="{{ approvalDecision.StageName }}" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="6"> Document Number </nz-form-label>
        <nz-form-control [nzSpan]="18">
          <nz-button-group>
            <a nz-button nzType="link" (click)="openDraftDocument(approvalDecision.DocEntry,approvalDecision)">{{
              approvalDecision.DocNum }}</a>
          </nz-button-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="6"> Draft Key </nz-form-label>
        <nz-form-control [nzSpan]="18">
          <nz-button-group>
            <a nz-button nzType="link" (click)="openDraftDocument(approvalDecision.DocEntry,approvalDecision)">{{
              approvalDecision.DocEntry }}</a>
          </nz-button-group>
        </nz-form-control>
      </nz-form-item>
      <nz-divider nzText="Answer"></nz-divider>
      <nz-form-item>
        <nz-form-label [nzSpan]="6"> Decision </nz-form-label>
        <nz-form-control [nzSpan]="18">
          <nz-select [disabled]="!((!global.enableDecisionControlsForAnyUser && approvalDecision.AuthorizerId === global.userIdentity.UserCode) || global.enableDecisionControlsForAnyUser)" [ngModelOptions]="{standalone: true}" [(ngModel)]="approvalDecision.AppStatus">
            <nz-option nzValue="W" nzLabel="Pending"></nz-option>
            <nz-option nzValue="Y" nzLabel="Approve"></nz-option>
            <nz-option nzValue="N" nzLabel="Not Approved"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="6"> Remarks </nz-form-label>
        <nz-form-control [nzSpan]="18">
          <input type="text" [disabled]="!((!global.enableDecisionControlsForAnyUser && approvalDecision.AuthorizerId === global.userIdentity.UserCode) || global.enableDecisionControlsForAnyUser)" [ngModelOptions]="{standalone: true}" nz-input [(ngModel)]="approvalDecision.AppRemark" />
        </nz-form-control>
      </nz-form-item>
    </form>

    <button nz-button *ngIf="(!global.enableDecisionControlsForAnyUser && approvalDecision.AuthorizerId === global.userIdentity.UserCode) || global.enableDecisionControlsForAnyUser" type="submit" nzType="primary" (click)="onApprovalSubmit(approvalDecision)">
      Update Decision
    </button>
  </nz-collapse-panel>
</nz-collapse>
